// extracted by mini-css-extract-plugin
export var arrows = "products-slider-module--arrows--Cgva7";
export var brand = "products-slider-module--brand--Ixf6-";
export var button = "products-slider-module--button--wbQfm";
export var category = "products-slider-module--category--sNjO7";
export var imageContainer = "products-slider-module--image-container--NPcRO";
export var productsWrapper = "products-slider-module--products-wrapper--LqHF0";
export var subtitle = "products-slider-module--subtitle--+bUHd";
export var title = "products-slider-module--title--8JYhJ";